// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"modal_dialogOverlay__VTQ_a","noscroll":"modal_noscroll__BoMBn"};